import React from 'react';

function Badge({ variant = 'listening', dot = false, children }) {
  return (
    <span className={`badge badge-${variant}`}>
      {dot && <span className="badge-dot" />}
      {children}
    </span>
  );
}

export default Badge;
